import React from "react";
import {ButtonIconBarcode, ButtonIconEdit} from "../../Components/Inputs";
import {getCopyStatusTextByValue} from "./libraryUtility";

interface LibraryItemCopyDisplayProps {
    copy: Record<string, any>;
    handleBarcode: (copyId: string) => void;
    handleEdit: ((id: string) => void) | null;
}

export const LibraryItemCopyDisplay = ({
                                           copy,
                                           handleBarcode,
                                           handleEdit,
                                       }: LibraryItemCopyDisplayProps) => {

    const isClickDisabled = !handleEdit;

    return <>
        <tr>
            <td className={`text-center`}>{copy.copyNumber}</td>
            <td>{copy.barCode}</td>
            <td>{copy.shelfLocation}</td>
            <td>{getCopyStatusTextByValue(copy.status)}</td>
            <td className={`action-cell`}>
                <ButtonIconEdit
                    disabled={isClickDisabled}
                    inputDescription={`for copy ${copy.number}`}
                    onClick={()=>handleEdit?.(copy.copyId)}
                />
                <ButtonIconBarcode
                    disabled={isClickDisabled}
                    inputDescription={`for copy ${copy.number}`}
                    onClick={()=>handleBarcode(copy.copyId)}
                />
            </td>
        </tr>
    </>;
};
